/**
 * The keys to be used for the dashboard queries and mutations, using an enum for better type safety and to avoid typos.
 *
 * @example
 * ```
 * useQuery({
 *   queryKey: [DashboardQueryKey.GET_ORDERS_REPORT],
 *   queryFn: async () => {
 *     // ...
 *   },
 * });
 * ```
 */
export const enum DashboardQueryKey {
  GET_ORDERS_REPORT = 'getOrdersReport',
  GET_RECENT_ESIM_ORDERS = 'getRecentEsimOrders',
  GET_RECENT_PSIM_ORDERS = 'getRecentPsimOrders',
}
